import React from 'react';
import { Tooltip, Button, Box, useTheme } from '@mui/material';
import { ArrowDownward, ArrowUpward, InfoOutlined } from '@mui/icons-material';

const SortingIcon = ({ direction }) =>
  direction === 'asc' ? <ArrowUpward style={{ fontSize: '18px' }} /> : <ArrowDownward style={{ fontSize: '18px' }} />;

const SortLabel = ({
  onSort,
  children: {
    props: {
      children: { value, tooltip }
    }
  },
  column: { sortDisabled },
  direction
}) => {
  const theme = useTheme();
  const columnLabel = (value || '').trim();
  const sortStateDescription = direction
    ? `Sorted ${direction === 'asc' ? 'ascending' : 'descending'}. Activate to sort ${direction === 'asc' ? 'descending' : 'ascending'}.`
    : 'Not sorted. Activate to sort ascending.';

  return (
    <>
      {!columnLabel && <Box aria-hidden="true" sx={{ width: 1, height: 1 }} />}
      {sortDisabled && !!columnLabel && (
        <Box
          sx={{
            cursor: 'default',
            display: 'flex',
            alignItems: 'center',
            padding: 0
          }}
        >
          {tooltip && (
            <Tooltip title={tooltip || 'Here goes the Tooltip text'}>
              <InfoOutlined
                sx={{
                  marginRight: theme.spacing(1.5),
                  fontSize: '1rem'
                }}
              />
            </Tooltip>
          )}
          <b>{columnLabel}</b>
        </Box>
      )}
      {!sortDisabled && !!columnLabel && (
        <Button
          onClick={onSort}
          sx={{
            display: 'flex',
            alignItems: 'center',
            padding: 0,
            minWidth: 'auto',
            textTransform: 'none',
            ...theme.typography.label,
            cursor: 'pointer',
            color: 'inherit',
            '&:hover': {
              backgroundColor: 'transparent',
              opacity: 0.8
            },
            '&:focus-visible': {
              outline: '2px solid',
              outlineOffset: '2px'
            },
            '&:active': {
              backgroundColor: 'transparent'
            }
          }}
          aria-label={columnLabel}
          aria-description={sortStateDescription}
          title={sortStateDescription}
          disableRipple
        >
          {tooltip && (
            <Tooltip title={tooltip || 'Here goes the Tooltip text'}>
              <InfoOutlined
                sx={{
                  marginRight: theme.spacing(1.5),
                  fontSize: '1rem'
                }}
              />
            </Tooltip>
          )}
          <b>{columnLabel}</b>
          {direction && <SortingIcon direction={direction} />}
        </Button>
      )}
    </>
  );
};

export default SortLabel;
